var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect, useState } from 'react';
import { Iframe } from '../../../../components/layer/Iframe';
import { readFinance } from '../../../utils/sessionStorage';
import { getSummaryOnePointFive } from '@oneaudi/stck-store/dist/selectors/financeSelector';
export function usePostData(vehicle, dataProfile, vehicleRaw) {
    var _a;
    const [postData, setPostData] = useState('');
    const skuItems = (_a = vehicleRaw === null || vehicleRaw === void 0 ? void 0 : vehicleRaw.detail) === null || _a === void 0 ? void 0 : _a.skuItems;
    useEffect(() => {
        function generatePostData() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const storeName = vehicle.type.toUpperCase() === 'N' ? 'VTP_FINANCING_NC' : 'VTP_FINANCING_UC';
                const finance = (_a = (yield readFinance(storeName))) !== null && _a !== void 0 ? _a : {};
                const financing = dataProfile !== 'no-finance-data' ? getSummaryOnePointFive(finance, vehicle.id) : {};
                const products = [];
                const dealerIds = [];
                const postDataString = JSON.stringify([
                    { aoz: products },
                    { audicode: vehicle.audiCode },
                    { financingData: financing },
                    { vehicleData: vehicle },
                    { dealerFilterIds: dealerIds },
                    { skuItems },
                ]);
                setPostData(postDataString);
            });
        }
        generatePostData();
    }, [vehicle, dataProfile, vehicleRaw]);
    return postData;
}
export const PostFormV2 = ({ link, postData, }) => {
    const formRef = useCallback((form) => {
        if (form) {
            form.submit();
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { action: link.url, id: "tile-post-form", target: "cta-iframe", method: "post", hidden: true, ref: formRef },
            React.createElement("input", { type: "hidden", name: "inquiry_json_data", value: postData })),
        React.createElement(Iframe, { src: "", originUrl: link.url })));
};
